// src/utils/config.js
import PromixLogo from "../../Assets/Promix.svg";
import CoopLogo from "../../Assets/RCCGG.png";

export const BRANDING = {
  // Cooperative Identity 1 (Primary / Internal)
  coopPrimary: {
    mainName: "Promix",
    secondName: "Cooperative Management",
    thirdName: "System",
    shortName: "PCMS",
    logo: PromixLogo, // Path in your public folder or full URL
  },

  coopSecondary: {
    mainName: "RCCG",
    secondName: "WORKERS FUND",
    thirdName: "COOPERATIVE",
    shortName: "RWFC",
    logo: CoopLogo, // Path in your public folder or full URL
  },

 
};